<style lang="stylus">
    .fileview-files-item
        position relative
        &:hover
            .grid-star:not(.readonly)
                display block !important

    .file-item-drag
        opacity .2
</style>
<template>
    <div
        class="fileview-files-item"
        :class="{
            'grid-item-active': fileSelected.includes(index),
        }"
        :data-index="index"
        :key="index"
        @contextmenu.prevent.stop="
            contextmenu($event, file, index);
            contextmenuEvent();
        "
        @click.exact="gridFileClickEvent(index, file)"
        @click.ctrl.exact="ctrlSelect(index)"
        @dblclick="!mulSelectMode && openFiles(file)"
    >
        <div class="grid-img-box">
            <img style="background: white" :src="fileImg" @error="coverError($event)" />
            <div class="grid-img-mask"></div>
        </div>
        <gridFileExpand
            v-if="file.info && ['files', 'openRecord', 'recycle'].includes(type)"
            :fileIndex="index"
            :fileSelected="fileSelected"
            :fileTagStr="fileTagStr(file.info.custom_tag)"
            :type="type"
            :edit="file.info && file.info.edit"
            :remainTime="file.remain_time"
            :fileTag="fileTag"
            @selectEvent="selectEvent"
            @expandTag="expandTag()"
            @changeTagStr="changeTagStr"
        />
        <div class="grid-titlebox">
            <Tooltip :content="fileName" :delay="500" :max-width="172" placement="bottom-start" class="titlebox-text">
                <p class="file-text" v-if="searchFileName">
                    <span v-for="item in searchFileName" :class="{ 'search-text-highlight': item == searchKey }">{{ item }}</span>
                </p>
                <span class="file-text" v-else>{{ fileName }}</span>
            </Tooltip>

            <div class="titlebox-icons">
                <iconSymbol
                    class="grid-tag"
                    v-if="!['recycle', 'publishFile', 'team'].includes(type)"
                    :class="{ active: tagStyle.fill != 'none' }"
                    :style="tagStyle"
                    name="grid-tag"
                />
                <iconSymbol
                    v-if="file.info && !['recycle', 'publishFile', 'team'].includes(type)"
                    class="grid-star"
                    :class="{ active: file.info.start_tag == 1, readonly: type != 'files' }"
                    name="filesitem-star"
                    :title="starTooltip"
                    @click.stop.native="setStarFile(file)"
                    @dblclick.stop.native=""
                />
                <iconSymbol
                    v-if="filePublish"
                    :style="{ fill: filePublish == 'pass' ? '#017fff' : '#ff8626' }"
                    name="publish-fill"
                    :title="filePublish == 'pass' ? $t('passPublish') : $t('pendingPublish')"
                />
            </div>
        </div>

        <div class="menu-box" @dblclick.stop>
            <div class="menu-right">
                <div class="fileview-icon" :title="$t('share')" v-if="['files'].includes(type)">
                    <iconSymbol :name="'pcview-shareIcon'" @click.stop.native="toShare(index, file)" />
                </div>
                <div
                    class="fileview-icon"
                    :title="$t('more')"
                    v-if="['publishFile', 'files', 'share', 'star', 'recycle', 'openRecord'].includes(type)"
                >
                    <iconSymbol :name="'pcview-moreIcon'" @click.stop.native="clickMenuIcon($event, file, index)" />
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Mixins } from "vue-property-decorator";
    import fileItem from "../fileItem";
    import gridFileExpand from "./gridFileExpand.vue";

    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            gridFileExpand,
        },
    })
    export default class gridFile extends Mixins(fileItem) {
        showCode: boolean = false;
        @Prop() cancelShare: any;
        @Prop() copyLink: any;
        @Prop() mulSelectMode: boolean;
        get userInfo() {
            return this.$store.state.userInfo;
        }
        get starTooltip() {
            if (!["files", "star", "openRecord"].includes(this.type)) {
                return this.$t("starFile");
            } else {
                return !!this.file.info.start_tag ? this.$t("cancel") : this.$t("set");
            }
        }
        get tagStyle() {
            let tagStr = this.file && this.file.info && this.file.info.custom_tag;
            if (tagStr) {
                if (tagStr == "edraw_1") {
                    return {
                        fill: "#efcd19",
                        stroke: "#efcd19",
                    };
                } else if (tagStr == "edraw_2") {
                    return {
                        fill: "#8eb85c",
                        stroke: "#8eb85c",
                    };
                } else if (tagStr == "edraw_3") {
                    return {
                        fill: "#e75f5b",
                        stroke: "#e75f5b",
                    };
                } else if (tagStr == "edraw_0") {
                    // 同无标签
                    return {
                        fill: "none",
                        stroke: "#d2d2d2",
                    };
                } else {
                    return {
                        fill: "#d2d2d2",
                        stroke: "#d2d2d2",
                    };
                }
            } else {
                return {
                    fill: "none",
                    stroke: "#d2d2d2",
                };
            }
        }
        fileTagStr(tag) {
            // 根据custom_tag返回对应文案
            let list = {
                edraw_0: "tag",
                edraw_1: "waitdone",
                edraw_2: "done",
                edraw_3: "waitchange",
            };
            let str = tag ? this.$t(list[tag]) : this.$t(list["edraw_0"]);
            return str || tag;
        }
        // 初始数据可以直接声明为实例的属性
        toShowCode() {
            this.$store.commit("setState", {
                type: "shareLinkCode",
                data: this.file.code,
            });
            this.$store.commit("setState", {
                type: "showShareCode",
                data: true,
            });
            // this.$nextTick(()=>{
            //     (<HTMLInputElement>this.$refs.codeCon).focus();
            // })
        }
        toShare(index = -1, e) {
            // 国内分享位绑定手机号先绑定手机号

            this.$track("cloudfile", "share");
            if (index != -1) {
                this.selectFile(index);
            }
            this.share(e);
        }
        coverError(e) {
            let lang = this.lang == "zh" ? "zh" : "en";
            e.target.src = require(`@/home/assets/img/files/default-files-${lang}.svg`);
        }
        gridFileClickEvent(index, file = null) {
            if (this.pcSaveInput) {
                this.$emit("changeSaveInputName", this.fileName);
                return; // 屏蔽pc保存文件状态
            }
            if (this.mulSelectMode) {
                this.selectFiles(index);
                this.fileSelected.length == 0 && this.$emit("cancelMulSelectMode");
            } else {
                this.openFiles(file);
            }
        }
        ctrlSelect(index) {
            if (this.pcSaveInput) return; // 屏蔽pc保存文件状态
            this.selectFiles(index);
            this.fileSelected.length == 0 && this.$emit("cancelMulSelectMode");
            this.fileSelected.length > 1 && !this.mulSelectMode && this.$emit("enterMulSelectMode");
        }
        selectEvent(index) {
            this.$emit("closeContextmenu");
            if (this.pcSaveInput) return; // 屏蔽pc保存文件状态
            if (!this.mulSelectMode && this.fileSelected[0] == index) {
                // 其他操作下可能有选择单个文件的情景出现
                this.selectFiles(index);
            } else if (!this.mulSelectMode) {
                this.selectFile(index);
                this.$emit("enterMulSelectMode");
            } else {
                this.selectFiles(index);
                this.fileSelected.length == 0 && this.$emit("cancelMulSelectMode");
            }
        }
        closeContextMenu() {
            this.$emit("closeContextmenu");
        }
        expandTag() {
            this.$emit("closeContextmenu");
        }
        changeTagStr(str) {
            this.$emit("setFileItemTagStr", str);
        }
        setStarFile(file) {
            // 仅“云文件”和“星标文件”tab可对星形按钮进行操作
            if (!["files", "star", "openRecord"].includes(this.type)) return;
            this.$emit("setStarFile", file);
        }
        contextmenuEvent() {
            this.$emit("contextmenuEvent");
        }
        clickMenuIcon($event, file, index) {
            if (this.$store.state.fileContextShow) {
                this.$store.commit("setState", {
                    type: "fileContextShow",
                    data: false,
                });
            } else {
                this.contextmenu($event, file, index);
            }
        }

        //生命周期
        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "open": "打开",
    "path": "路径",
    "tag": "标签",
    "share": "分享",
    "copyLink": "复制链接",
    "cancelShare": "取消分享",
    "showCode": "显示密码",
    "passPublish": "已公开",
    "pendingPublish": "发布中",
    "lockedFile": "文件已加密，请解密后再分享文件",
    "teamEditWarn": "正在编辑该文件",
    "none": "无",
    "waitdone": "未完成",
    "done": "已完成",
    "waitchange": "需修改",
    "set": "收藏",
    "cancel": "取消收藏",
    "starFile": "收藏文件",
    "more": "更多"
  },
  "de": {
    "open": "Öffnen",
    "path": "Pfad",
    "tag": "Etikette",
    "share": "Teilen ",
    "copyLink": "Link kopieren",
    "cancelShare": "Teilen ausfallen",
    "showCode": "Passwort anzeigen",
    "passPublish": "Öffentlicht",
    "pendingPublish": "Veröffentlicht",
    "lockedFile": "Die Datei ist verschlüsselt. Bitte entschlüsseln Sie sie vor dem Teilen",
    "teamEditWarn": "Diese Datei wird bearbeitet",
    "none": "Nichts",
    "waitdone": "Unfertigt",
    "done": "Gefertigt",
    "waitchange": "Bearbeitbar",
    "set": "Einstellen Sternen",
    "cancel": "Abbrechen Sternen",
    "starFile": "Sternendatei",
    "more": "Mehr"
  },
  "en": {
    "open": "Open",
    "path": "Path",
    "tag": "Tag",
    "share": "Share",
    "copyLink": "Copy link",
    "cancelShare": "Stop sharing",
    "showCode": "Show password",
    "passPublish": "Public",
    "pendingPublish": "Publishing",
    "lockedFile": "The file is encrypted, please decrypt it before sharing",
    "teamEditWarn": "Editing this file",
    "none": "No",
    "waitdone": "In Process",
    "done": "Completed",
    "waitchange": "Need to be modified",
    "set": "Star",
    "cancel": "Unstar",
    "starFile": "Starred File",
    "more": "More"
  },
  "es": {
    "open": "Abierto",
    "path": "Camino",
    "tag": "etiqueta",
    "share": "Compartir",
    "copyLink": "Copiar enlace",
    "cancelShare": "Cancelar compartir",
    "showCode": "Mostrar contraseña",
    "passPublish": "Esta publicado",
    "pendingPublish": "Lanzando",
    "lockedFile": "El archivo está cifrado, descifrelo antes de compartirlo",
    "teamEditWarn": "Editando este archivo",
    "none": "Nada",
    "waitdone": "Deshecho",
    "done": "Hecho",
    "waitchange": "Es necesario modificar",
    "set": "Establecer estrella",
    "cancel": "Cancelar estrella",
    "starFile": "Archivo destacado",
    "more": "Más"
  },
  "pt": {
    "open": "Abrir",
    "path": "Caminho",
    "tag": "rótulo",
    "share": "partilhar",
    "copyLink": "copiar ligação",
    "cancelShare": "cancelar partilha",
    "showCode": "mostrar password",
    "passPublish": "Público",
    "pendingPublish": "Anunciando",
    "lockedFile": "O arquivo está criptografado, descriptografe-o antes de compartilhar",
    "teamEditWarn": "Editando este arquivo",
    "none": "nada",
    "waitdone": "incompleto",
    "done": "Concluído",
    "waitchange": "Precisa ser modificado",
    "set": "Definir estrela",
    "cancel": "Cancelar estrela",
    "starFile": "Documentos estrelados",
    "more": "Mais"
  },
  "it": {
    "open": "etichetta",
    "path": "Percorso",
    "tag": "etichetta",
    "share": "Condividi",
    "copyLink": "Copia Collegamento",
    "cancelShare": "Annulla Condivisione",
    "showCode": "Mostra Password",
    "passPublish": "È pubblicato",
    "pendingPublish": "Pubblica in corso",
    "lockedFile": "Il file è crittografato, decrittalo prima di condividerlo",
    "teamEditWarn": "Modifica di questo file",
    "none": "Niente",
    "waitdone": "Incompiuto",
    "done": "Completato",
    "waitchange": "Bisogna modificare",
    "set": "Imposta stella",
    "cancel": "Annulla stella",
    "starFile": "File Stella",
    "more": "Di Più"
  },
  "jp": {
    "open": "開く",
    "path": "パス",
    "tag": "ラベル",
    "share": "共有",
    "copyLink": "リンクをコピー",
    "cancelShare": "共有をキャンセル",
    "showCode": "パスワードを表示",
    "passPublish": "公開済み",
    "pendingPublish": "公開中",
    "lockedFile": "ファイルは暗号化されています。ファイルを共有する前に復号化してください。",
    "teamEditWarn": "ファイルを編集しています。",
    "none": "なし",
    "waitdone": "未完成",
    "done": "完了",
    "waitchange": "修正予定",
    "set": "スターを追加",
    "cancel": "スターを外す",
    "starFile": "スターファイル",
    "more": "もっと"
  },
  "fr": {
    "open": "Allumer",
    "path": "Chemin",
    "tag": "étiqueter",
    "share": "Partager",
    "copyLink": "Copier le lien",
    "cancelShare": "Annuler le partage",
    "showCode": "Montrer le mot de passe",
    "passPublish": "Publique",
    "pendingPublish": "Annoncer",
    "lockedFile": "Le fichier est chiffré, veuillez le déchiffrer avant de le partager",
    "teamEditWarn": "Modifier ce fichier",
    "none": "Rien",
    "waitdone": "Inachevé",
    "done": "Complété",
    "waitchange": "Besoin d'être modifié",
    "set": "Mise en place étoile",
    "cancel": "Annuler étoile",
    "starFile": "Fichier étoile",
    "more": "Plus"
  },
  "tw": {
    "open": "打開",
    "path": "路徑",
    "tag": "標籤",
    "share": "分享",
    "copyLink": "複製連結",
    "cancelShare": "取消分享",
    "showCode": "顯示密碼",
    "passPublish": "已公開",
    "pendingPublish": "發佈中",
    "lockedFile": "檔案已加密，請解密後再分享檔案",
    "teamEditWarn": "正在編輯該檔案",
    "none": "無",
    "waitdone": "未完成",
    "done": "已完成",
    "waitchange": "需修改",
    "set": "設置星標",
    "cancel": "取消星標",
    "starFile": "星標檔案",
    "more": "更多"
  },
  "kr": {
    "open": "열기",
    "path": "경로",
    "tag": "태그",
    "share": "공유",
    "copyLink": "링크 복사",
    "cancelShare": "공유 취소",
    "showCode": "암호 표시",
    "passPublish": "공개됨",
    "pendingPublish": "게시 중",
    "lockedFile": "파일이 암호화되어 있습니다. 공유하기 전에 해독하세요~",
    "teamEditWarn": "파일 편집 중입니다.",
    "none": "없음",
    "waitdone": "미완성",
    "done": "완료",
    "waitchange": "수정 필요",
    "set": "즐겨찾기",
    "cancel": "즐겨찾기 취소",
    "starFile": "별표 파일",
    "more": "더보기"
  },
  "id": {
    "open": "Buka",
    "path": "Path",
    "tag": "Tag",
    "share": "Bagikan",
    "copyLink": "Salin tautan",
    "cancelShare": "Berhenti berbagi",
    "showCode": "Tampilkan kata sandi",
    "passPublish": "Publik",
    "pendingPublish": "Menerbitkan",
    "lockedFile": "File dienkripsi. Dekripsikan file sebelum dibagikan",
    "teamEditWarn": "Mengedit file ini",
    "cancel": "Batalkan",
    "waitdone": "Sedang Diproses",
    "done": "Selesai",
    "waitchange": "Perlu dimodifikasi",
    "set": "Tambahkan bintang",
    "cancel": "Batalkan bintang",
    "starFile": "File Berbintang",
    "more": "Lagi"
  }
}
</i18n>
